import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SubscriptionStatus = () => {
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  useEffect(() => {
    // Mock subscription data
    const mockSubscription = {
      plan: 'Pro Plan',
      status: 'active',
      expiryDate: '2025-08-26',
      daysRemaining: 31,
      features: ['Unlimited Users', 'Advanced Analytics', 'Priority Support', 'API Access'],
      isExpiringSoon: false
    };

    setSubscriptionData(mockSubscription);
  }, []);

  const handleUpgrade = () => {
    setShowUpgradeModal(true);
  };

  const closeUpgradeModal = () => {
    setShowUpgradeModal(false);
  };

  if (!subscriptionData) {
    return null;
  }

  const { plan, status, daysRemaining, features, isExpiringSoon } = subscriptionData;

  return (
    <>
      <div className="mt-8 p-4 bg-card border border-border rounded-lg shadow-elevation-1">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-2">
            <div className={`w-3 h-3 rounded-full ${
              status === 'active' ? 'bg-success' : 
              status === 'expiring' ? 'bg-warning' : 'bg-error'
            }`}></div>
            <h3 className="font-semibold text-foreground">{plan}</h3>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Calendar" size={14} color="var(--color-muted-foreground)" />
            <span className="text-xs text-muted-foreground">
              {daysRemaining} days left
            </span>
          </div>
        </div>

        {isExpiringSoon && (
          <div className="mb-3 p-2 bg-warning/10 border border-warning/20 rounded-md">
            <div className="flex items-center space-x-2">
              <Icon name="AlertTriangle" size={14} color="var(--color-warning)" />
              <p className="text-xs text-warning">
                Your subscription expires soon. Upgrade to continue using all features.
              </p>
            </div>
          </div>
        )}

        <div className="space-y-2 mb-4">
          <p className="text-xs font-medium text-foreground">Included Features:</p>
<div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {features.map((feature, index) => (
              <div key={index} className="flex items-center space-x-1">
                <Icon name="Check" size={12} color="var(--color-success)" />
                <span className="text-xs text-muted-foreground">{feature}</span>
              </div>
            ))}
          </div>
        </div>

        <Button
          variant="outline"
          size="sm"
          fullWidth
          onClick={handleUpgrade}
          iconName="Crown"
          iconPosition="left"
          iconSize={14}
        >
          Manage Subscription
        </Button>
      </div>

      {/* Upgrade Modal */}
      {showUpgradeModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-1001">
<div className="bg-card border border-border rounded-lg shadow-elevation-3 w-full max-w-md mx-4 sm:mx-6">
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-foreground">Subscription Management</h3>
                <button
                  onClick={closeUpgradeModal}
                  className="text-muted-foreground hover:text-foreground transition-smooth"
                >
                  <Icon name="X" size={20} />
                </button>
              </div>

              <div className="space-y-4">
                <div className="p-4 bg-primary/5 border border-primary/10 rounded-lg">
                  <div className="flex items-center space-x-3 mb-3">
                    <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                      <Icon name="Crown" size={20} color="white" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground">Current: Pro Plan</h4>
                      <p className="text-sm text-muted-foreground">₹4,999/month</p>
                    </div>
                  </div>
                  <p className="text-sm text-muted-foreground">
                    Your subscription is active and includes all premium features.
                  </p>
                </div>

                <div className="space-y-3">
                  <Button
                    variant="default"
                    fullWidth
                    iconName="CreditCard"
                    iconPosition="left"
                    iconSize={16}
                  >
                    Update Payment Method
                  </Button>
                  
                  <Button
                    variant="outline"
                    fullWidth
                    iconName="Download"
                    iconPosition="left"
                    iconSize={16}
                  >
                    Download Invoice
                  </Button>
                  
                  <Button
                    variant="ghost"
                    fullWidth
                    iconName="HelpCircle"
                    iconPosition="left"
                    iconSize={16}
                  >
                    Contact Support
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SubscriptionStatus;